import { render, staticRenderFns } from "./serverForm.vue?vue&type=template&id=4422f6e7&scoped=true&"
import script from "./serverForm.vue?vue&type=script&lang=js&"
export * from "./serverForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4422f6e7",
  null
  
)

export default component.exports